import { forwardRef } from 'react'

import { TextHTML } from '@/components/typography'

import { TSelectPlanProps } from './types'

// eslint-disable-next-line react/display-name
export const SelectPlan = forwardRef<HTMLDivElement, TSelectPlanProps>(
  (
    {
      planTitle,
      planDetails,
      selectPlan,
      selectedPlan,
      isShadow,
      additionalBlock,
      isShowInput,
      concatPrice,
    }: TSelectPlanProps,
    ref
  ) => {
    return (
      <div className="select-plan-container" ref={ref}>
        {planTitle && <TextHTML className="title" title={planTitle} />}
        {additionalBlock}
        {planDetails.map((plan) => {
          const [dollar, cents] = concatPrice
            ? [plan.periodPrice.toString(), '']
            : plan.periodPrice.toString().split('.')
          const isCurrentPlan = selectedPlan.planId === plan.planId

          const onClick = () => {
            selectPlan(plan)
          }

          let className = 'plan-container'
          const classContainerWrapper = className + '-wrapper'
          if (isCurrentPlan) {
            className += ' selected'
          }
          if (Boolean(plan.extraTop)) {
            className += ' extra'
          }

          return (
            <div className={classContainerWrapper} key={plan.planId}>
              {plan.title && <div className="plan-title">{plan.title}</div>}
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
              <div className={className} onClick={onClick}>
                {plan.extraTop && <div className="extra-top">{plan?.extraTop}</div>}
                {isShowInput && (
                  <input
                    id={`plan_${plan.planId}`}
                    type="radio"
                    name="plan_type"
                    value={plan.planId}
                    checked={isCurrentPlan}
                    onChange={onClick}
                    className={'radio-button'}
                  />
                )}
                <div className="plan-inner-container">
                  <div className="price-info-container">
                    <div className="plan-name">{plan.name}</div>
                    {plan.tag && <div className="tag">{plan.tag}</div>}
                    <div className="price-alt">
                      <span className="price crossed">
                        {plan.currencySign}
                        {plan.crossedPrice}
                      </span>
                      &nbsp;
                      <span className="price">
                        {plan.currencySign}
                        {plan.trialPrice || plan.price}
                      </span>
                      &nbsp;
                      <span className="total-period-label">{plan.totalPeriodLabel}</span>
                    </div>
                  </div>
                  <div className="period-price-container">
                    {plan.crossedPeriodPrice && (
                      <sup className="crossed-period-price">
                        {plan.currencySign}
                        {plan.crossedPeriodPrice}
                      </sup>
                    )}
                    <sup className="currency">{plan.currencySign}</sup>
                    <span className="period-price">{dollar}</span>
                    <sup className="cents">{cents}</sup>
                    <sub className="period-label">{plan.periodLabel || '/week'}</sub>
                  </div>
                </div>
                {isShadow && (
                  <>
                    <div className="floating-shadow" />
                    <div className="line" />
                  </>
                )}
              </div>
            </div>
          )
        })}
      </div>
    )
  }
)

// eslint-disable-next-line react/display-name
export const SelectPlanV2 = forwardRef<HTMLDivElement, TSelectPlanProps>(
  (
    {
      planTitle,
      planDetails,
      selectPlan,
      selectedPlan,
      additionalBlock,
      concatPrice,
    }: TSelectPlanProps,
    ref
  ) => {
    return (
      <div className="select-plan-section" ref={ref}>
        {planTitle && <TextHTML className="title" title={planTitle} />}
        {additionalBlock}
        {planDetails.map((plan) => {
          const [dollar, cents] = concatPrice
            ? [plan.periodPrice.toString(), '']
            : plan.periodPrice.toString().split('.')
          const isCurrentPlan = selectedPlan.planId === plan.planId
          const onClick = () => {
            selectPlan(plan)
          }
          // let className = 'plan-container'
          let className = 'plan-container-v2'
          let classContainerWrapper = className + '-wrapper'
          if (isCurrentPlan) {
            classContainerWrapper += ' selected'
          }
          if (Boolean(plan.extraTop)) {
            className += ' with-extra'
          }
          if (Boolean(plan.tag)) {
            className += ' with-tag'
          }
          return (
            <div className="select-plan-container-v2" key={plan.planId}>
              {plan.title && <span className="plan-title">{plan.title}</span>}
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
              <div className={classContainerWrapper} onClick={onClick}>
                {plan.extraTop && (
                  <div className="extra-top-container ">
                    <span className="extra-top">{plan.extraTop}</span>
                  </div>
                )}
                <div className={className}>
                  <div className="left-info-container">
                    <span className="plan-name ">{plan.name} </span>
                    {plan.tag && (
                      <div className="tag-container">
                        <span className="tag ">{plan.tag}</span>
                      </div>
                    )}
                    <span className="plan-price">
                      <span className="plan-price crossed">
                        {!plan.overrideCurrencyCode && plan.currencySign}
                        {plan.crossedPrice}
                      </span>
                      &nbsp;
                      {plan.currencySign}
                      {plan.overrideMainPrice || plan.trialPrice || plan.price}
                      {plan.overrideCurrencyCode && ` ${plan.overrideCurrencyCode}`}
                    </span>
                  </div>
                  <div className="right-info-container  ">
                    <span className="plan-price crossed red">
                      {!plan.overrideCurrencyCode && plan.currencySign}
                      {plan.crossedPeriodPrice}
                    </span>
                    <span className="currency number ">{plan.currencySign}</span>
                    <span className="number integral-part  ">{dollar}</span>
                    <div className="column-container period-label-container">
                      <span className="fractional-part number">
                        {cents}
                        <span>{plan.overrideCurrencyCode && ` ${plan.overrideCurrencyCode}`}</span>
                      </span>
                      <span className="period-label number">{plan.periodLabel || 'per week'}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    )
  }
)
